document.addEventListener("DOMContentLoaded", function() {
  let productsSelect = document.getElementById("products");
  let unitSelect = document.getElementById("unit");

  // Listen for changes to the products select element
  document.getElementById("products").addEventListener("change", () => {
    // Get an array of selected product values
    let selectedProducts = Array.from(productsSelect.options)
      .filter(option => option.selected)
      .map(option => option.value);

    // If the selected products includes 'hr', 'cr', 'gi', 'az', 'g90', 'az50', 'plate' hide the $/GT option in the unit selects
    unitSelect.querySelector('option[value="gt"]').style.display = [
      "hr",
      "cr",
      "gi",
      "az",
      "g90",
      "az50",
      "plate"
    ].some(item => selectedProducts.includes(item))
      ? "none"
      : "block";
  });

  document.getElementById("create-chart").addEventListener("click", createChart, false);
  document.getElementById("clear-data").addEventListener("click", function(e){
    e.preventDefault();
    window.location.reload();
  });

  // Get the tab buttons
  let tabButtons = document.querySelectorAll(".smu-price-interactive__tab-link");
  let tabContents = document.querySelectorAll(".smu-price-interactive__tab-content");

  // Add an event listener to each tab button
  tabButtons.forEach(button => {
    button.addEventListener("click", () => {
      tabContents.forEach(content => {
        console.log(content);
        content.style.display = "none";
      });

      let tabContent = document.getElementById(button.dataset.tab);
      tabContent.style.display = "block";
    });
  });
});

function createChart(event) {
  event.preventDefault();

  let tabs = document.querySelector(".smu-price-interactive__tab");
  tabs.style.display = "block";

  let products = Array.from(document.querySelector("#products").selectedOptions).map(option => option.value);
  let value = document.getElementById("value").value;
  let view = document.getElementById("view").value;
  let unit = document.getElementById("unit").value;
  let extraData = document.getElementById("extra-data").value;

  let path = `product/${products}/value/${value}/view/${view}/unit/${unit}`;

  if (extraData) {
    path += `/extra_data/${extraData}`;
  }

  fetch(`/wp-json/pugpig/steelmarketupdate/chart/${path}/`)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log(data[0]);
      if (data[1]) {
        let table = document.getElementById("table");
        table.innerHTML = data[1];
      }

      if (data[0]) {
        let chart_config = JSON.parse(data[0]);
        Highcharts.chart("chart", chart_config);
        document.getElementsByClassName("smu-price-interactive__tab")[0].style.display = "block"
        document.getElementById("chart").style.display = "block";
        addUnitInTableHeader();
      }
    })
    .catch(error => console.error(`Error: ${error.message}`));
}

function addUnitInTableHeader() {
  // get the table header row element
  let tableHeaderRow = document.querySelector("table thead tr");

  let extraData = document.getElementById("extra-data").value;

  let headerCells = Array.from(tableHeaderRow.querySelectorAll("th"));
  headerCells = extraData ? headerCells.slice(1, end) : headerCells.slice(1);

  let unit = document.getElementById("unit").value.toUpperCase();
  let value = document.getElementById("value").value;

  // loop through the header cells and change the text content
  headerCells.forEach(cell => {
    cell.textContent += " (" + value + " $/" + unit + ")";
  });
}
